import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { WeeklyResultByStoreReportService } from '../weekly-result-by-store-report/weekly-result-by-store-report.service';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { ShopinfoModel } from '../../system/shopinfo/model/shopinfo.model';
import { DatePipe } from '@angular/common';
import { TerminalService } from '../../system/terminal/terminal.service';
import { WeeklyReportService } from './weekly-report.service';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-weekly-report',
  standalone: false,
  templateUrl: './weekly-report.component.html',
  styleUrl: './weekly-report.component.scss'
})
export class WeeklyReportComponent {


  title: string = "Weekly Sales";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  requestData: any = null;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  terminalListData: any = [];
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately




  curFinYear!: string; // Add this to your component properties  
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private weeklyReportService: WeeklyReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private permissionService: PermissionService,

    public dialog: MatDialog, private datePipe: DatePipe, private ternimalService: TerminalService,) {

    const userData = sessionStorage.getItem('user');
    if (userData) {
      this.requestData = JSON.parse(userData);
      console.log('Request Data:', this.requestData);
    } else {
      console.log('Data not found in sessionStorage');
    }


    this.editForm = this.builder.group({
      // year: this.builder.control( ''),
      year: this.builder.control(null),
      week_no: this.builder.control([]),
      description: this.builder.control([]),
      decimal_places: this.builder.control([]),
      // sort_by: this.builder.control('shop_name'),
      // sort_order: this.builder.control('asc'),
      excludeSales: this.builder.control(1),
      excludeExpense: this.builder.control(1),
      terminalFilter: ['']




    });

    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });

    this.permission = permissionService.getPagePermission("weekly-report");
    console.log(this.permission);
    // Load saved data if it exists
    // this.loadFromSessionStorage();

  }
  // getCurrentWeek(weeks: any[]): any {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Normalize time to midnight for accurate comparison

  //   return weeks.find(week => {
  //     const startDate = new Date(week.start_date);
  //     const endDate = new Date(week.end_date);
  //     return today >= startDate && today <= endDate;
  //   });
  // }
  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }


  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedShopIds = this.terminalListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: shopIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 0
    };

    // Save to sessionStorage
    sessionStorage.setItem('weeklyStoreReportData', JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem('weeklyStoreReportData');
    if (savedData) {
      const reportData = JSON.parse(savedData);

      // Set form values
      this.editForm.patchValue({
        year: reportData.year,
        week_no: reportData.weekNo,
        sort_by: reportData.sortBy,
        sort_order: reportData.sortDir
      }, { emitEvent: false }); // Prevent infinite loop

      // Set shop selections (if shop IDs were saved)
      if (reportData.shopId && reportData.shopId.length > 0) {
        this.terminalListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        // If no shops were selected before, reset all to false (treat as "ALL")
        this.terminalListData.forEach((shop: any) => shop.selected = false);
      }

      // Manually trigger year change if needed
      if (reportData.year) {
        this.onYearChange();
      }
    }
  }

  ngOnInit(): void {
    this.loadData();
    this.TerminalList();

  }



  // onYearChange(): void {
  //   this.selectedYear = this.editForm.get('year')?.value;
  //   console.log('Selected Year:', this.selectedYear);

  //   // Find the selected financial year from financialYears array
  //   const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

  //   if (selectedFinYear) {
  //     // Map the weeks to the format needed for the dropdown
  //     this.weeks = selectedFinYear.weeks.map((week: any) => ({
  //       ...week,


  //     displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
  //     }));

  //     // Set the first week as default if weeks exist
  //     if (this.weeks.length > 0) {
  //       this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
  //     }
  //   } else {
  //     this.weeks = [];
  //     this.editForm.get('week_no')?.setValue(null);
  //   }
  // }





  // loadData(): void {
  //   console.log('Selected Year:', this.selectedYear);

  //   this.weeklyReportService.getWeekNoList().subscribe(response => {
  //     console.log('API Response:', response);

  //     if (response.status === 'SUCCESS') {
  //       this.financialYears = response.data.finYears;
  //       this.years = this.financialYears.map(fy => fy.year);

  //       // Only set the default value if the form control is empty
  //       if (!this.editForm.get('year')?.value) {
  //         this.curFinYear = response.data.curFinYear;
  //         if (this.curFinYear) {
  //           const yearValue = parseInt(this.curFinYear);
  //           this.editForm.get('year')?.setValue(yearValue, { emitEvent: false });

  //           // Set weeks for the current financial year
  //           const currentFinYear = this.financialYears.find(fy => fy.year === yearValue);
  //           if (currentFinYear) {
  //             this.weeks = currentFinYear.weeks.map((week: any) => ({
  //               ...week,
  //               displayText : `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
  //               // displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
  //             }));
  //             // Set the current week as default
  //             const currentWeek = this.getCurrentWeek(this.weeks);
  //             if (currentWeek) {
  //               this.editForm.get('week_no')?.setValue(currentWeek.week_no);
  //             } else if (this.weeks.length > 0) {
  //               // Fallback to first week if current week not found
  //               this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
  //             }
  //           }
  //         }
  //       }

  //       console.log('Financial Years Data:', this.financialYears);
  //     } else {
  //       console.error('API Error:', response.message);
  //     }
  //   });
  // }
  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };
  }

  loadData(): void {
    let requestData = this.buildRequestData();
    this.weeklyReportService.getWeekNoList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.financialYears = response.data.finYears;
        this.years = this.financialYears.map(fy => fy.year);
        this.curFinYear = response.data.curFinYear;
        const currentYearValue = parseInt(this.curFinYear.split('-')[0]);

        // Filter financialYears to include only up to the current year
        this.financialYears = response.data.finYears.filter((fy: any) =>
          fy.year <= currentYearValue
        );
        this.years = this.financialYears.map(fy => fy.year);

        if (!this.editForm.get('year')?.value) {
          const currentYearValue = parseInt(this.curFinYear.split('-')[0]); // Adjust based on curFinYear format
          const currentFinYear = this.financialYears.find(fy => fy.year === currentYearValue);

          if (currentFinYear) {
            this.editForm.get('year')?.setValue(currentYearValue, { emitEvent: false });

            let weeksArray = currentFinYear.weeks;
            const currentWeek = this.getCurrentWeek(weeksArray);

            // Filter weeks if current year
            if (currentWeek) {
              weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
            }

            // Sort weeks in descending order by week_no
            weeksArray = weeksArray.sort((a: any, b: any) => b.week_no - a.week_no);

            this.weeks = weeksArray.map((week: any) => ({
              ...week,
              displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
            }));

            // Set current week or first week (now first is highest week_no)
            if (currentWeek) {
              this.editForm.get('week_no')?.setValue(currentWeek.week_no);
            } else if (this.weeks.length > 0) {
              this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
            }
          }
        }
      }
    });
  }

  // In onYearChange() method

  onYearChange(): void {
    const selectedYear = this.editForm.get('year')?.value;
    const selectedFinYear = this.financialYears.find(fy => fy.year === selectedYear);

    if (selectedFinYear) {
      let weeksArray = selectedFinYear.weeks;
      const isCurrentYear = selectedYear === parseInt(this.curFinYear.split('-')[0]); // Adjust if needed

      if (isCurrentYear) {
        const currentWeek = this.getCurrentWeek(weeksArray);
        if (currentWeek) {
          weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
        }
      }

      // Sort weeks in descending order by week_no
      weeksArray = weeksArray.sort((a: any, b: any) => b.week_no - a.week_no);

      this.weeks = weeksArray.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
      }));

      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }






  TerminalList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "name", order: "ASC" }] } }

    this.ternimalService.getTerminalList(requestData).subscribe(
      (response: any) => {
        this.terminalListData = [];
        var index = 0;
        response.data.terminals.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
        console.log(this.terminalListData)

      },
      (error: any) => {

      },
    );
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }




  onShopSelectionChange(): void {
    this.saveToSessionStorage();
  }

  navigateToWeeklyReport() {
    this.router.navigate(['/weekly-result-store-report-view']);
    // or with parameters if needed:
    // this.router.navigate(['/weekly-result-store-report-view', {param: value}]);
  }

  exportClicked(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    this.IsDownloading = true;
    // Use terminal codes instead of IDs
    const selectedTerminalCodes = this.terminalListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.code);
    const selectedShops = this.terminalListData.filter((shop: any) => shop.selected);
    const terminalCodes = selectedTerminalCodes.length > 0 ? selectedTerminalCodes : [];
    const shopNames = selectedShops.length > 0 ? selectedShops.map((shop: any) => shop.item.name) : [];

    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      terminalId: terminalCodes,
      shopName: this.requestData.shop_info.name,
      excludeSales: this.editForm.get('excludeSales')?.value,
      excludeExpense: this.editForm.get('excludeExpense')?.value,
    };

    if (reportData) {
      this.weeklyReportService.getWeekNoExportList(reportData).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);
              if (json.status === 'NO_DATA_FOUND' || json.status === 204) {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data!!!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }
            } catch (e) {
              // Not JSON, treat as file
              const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'weekly-report.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;
            }
          };
          reader.readAsText(response);
        },
        error: (error) => {
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }

  // In your form group:
  // terminalFilterAll: [''],
  // terminalFilterSelected: [''],

  // --- Terminal Filter Logic ---
  showSelectedTerminalOnly: boolean = false;
  isExpandedTerminal: boolean = false;
  isExpandedSort: boolean = false;

  getSelectAllIconTerminal(): string {
    const selectedCount = this.terminalListData.filter((item: any) => item.selected)
      .length;
    if (selectedCount === 0) {
      return 'check_box_outline_blank';
    } else if (selectedCount === this.terminalListData.length && this.terminalListData.length > 0) {
      return 'check_box';
    } else {
      return 'indeterminate_check_box';
    }
  }

  toggleSelectAllTerminal(): void {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    this.terminalListData.forEach((item: any) => (item.selected = !allSelected));
    this.onShopSelectionChange();
  }

  get filteredTerminalListData() {
    const filter =
      this.editForm.get('terminalFilter')?.value?.toLowerCase() || '';
    return this.terminalListData.filter((item: any) => {
      const matchesFilter = !filter || item.item.name.toLowerCase().includes(filter);
      const matchesShowSelected = !this.showSelectedTerminalOnly || item.selected;
      return matchesFilter && matchesShowSelected;
    });
  }

  get selectedTerminalSourcesCount(): number {
    return (
      this.terminalListData?.filter((item: any) => item.selected)?.length || 0
    );
  }
}